import React from 'react';
import { Check, ArrowRight, ClipboardList } from 'lucide-react';
import { pathway, brand } from '../../mock';

const Pathways = () => {
  return (
    <section id="pathways" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">{pathway.eyebrow}</div>
          <h2 className="font-serif text-4xl lg:text-6xl text-green tracking-tight leading-[1.04]">
            One integrated <em className="italic">pathway</em>, built around you.
          </h2>
          <p className="mt-5 text-[var(--brand-mute)] text-lg max-w-2xl">
            Whether you’re navigating complex, unresolved symptoms or looking for proactive lifestyle-focused care — our single entry pathway brings the whole team together for you.
          </p>
        </div>

        <div className="mt-14 reveal">
          <div className="card-hover relative rounded-[28px] p-8 lg:p-12 border border-[var(--brand-green)] bg-[var(--brand-green)] text-[var(--brand-cream)] overflow-hidden">
            <div className="absolute -right-24 -bottom-24 h-80 w-80 rounded-full bg-[var(--brand-gold)] opacity-10 blur-2xl" />
            <div className="relative grid lg:grid-cols-12 gap-10 lg:gap-16">
              <div className="lg:col-span-6">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold-2)]">Entry Pathway</div>
                    <h3 className="font-serif text-3xl lg:text-5xl mt-3 leading-[1.05]">
                      {pathway.title}
                    </h3>
                    <div className="mt-3 text-sm opacity-80">
                      Lead Clinician: <span className="font-medium">{pathway.lead}</span>
                    </div>
                  </div>
                  <div className="h-14 w-14 rounded-full grid place-items-center shrink-0 bg-[var(--brand-cream)] text-[var(--brand-green)]">
                    <ClipboardList size={22} strokeWidth={1.6} />
                  </div>
                </div>

                <p className="mt-6 text-[16px] leading-relaxed opacity-90 max-w-lg">
                  {pathway.description}
                </p>

                <a href={brand.bookingUrl} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex btn-primary !bg-[var(--brand-gold)] !border-[var(--brand-gold)] !text-[var(--brand-green)] hover:!bg-[var(--brand-gold-2)] text-sm">
                  Book this assessment <ArrowRight size={16} />
                </a>
              </div>

              <div className="lg:col-span-6 grid sm:grid-cols-2 gap-8">
                <div>
                  <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold-2)] mb-4">What’s Included</div>
                  <ul className="space-y-3">
                    {pathway.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-3 text-[15px]">
                        <span className="mt-1 h-4 w-4 rounded-full grid place-items-center shrink-0 bg-[var(--brand-cream)] text-[var(--brand-green)]">
                          <Check size={10} strokeWidth={3} />
                        </span>
                        <span className="opacity-95">{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold-2)] mb-4">Perfect For…</div>
                  <ul className="space-y-3">
                    {pathway.perfectFor.map((f) => (
                      <li key={f} className="flex items-start gap-3 text-[15px]">
                        <span className="mt-1 h-4 w-4 rounded-full grid place-items-center shrink-0 bg-[var(--brand-gold)] text-[var(--brand-green)]">
                          <Check size={10} strokeWidth={3} />
                        </span>
                        <span className="opacity-95">{f}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pathways;
